import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
export default {
  name: "ImportSupplierPricesHeader",
  props: {
    status: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    statusOptions: {
      type: Array,
      required: true
    }
  },
  computed: {
    selected: {
      get: function get() {
        return this.status;
      },
      set: function set(val) {
        this.$emit("update:status", val);
      }
    }
  },
  methods: {
    colorFor: function colorFor(id) {
      switch (id) {
        case 0:
          return "danger";
        case 1:
          return "success";
        case 2:
          return "warning";
        default:
          return "grey";
      }
    },
    removeSelection: function removeSelection(item) {
      var updated = this.selected.filter(function (i) {
        return i !== item.id;
      });
      this.$emit("update:status", updated);
    }
  }
};